<main class="main-not-found">
  <article class="not-found-article">
    <h1 class="article-title">
      No configuration found for the determined club.
    </h1>
  </article>
</main>
